import React, {
  createContext, useContext, useState, useCallback,
} from 'react';

const SelectedLeadsContext = createContext({
  selectedLeadIds: [],
  selectedChannelKind: null,
  toggleLead: () => null,
  clearSelection: () => null,
  canSelectLead: () => true,
});

export const useSelectedLeads = () => useContext(SelectedLeadsContext);

export const SelectedLeadsProvider = ({ children }) => {
  const [selectedLeadIds, setSelectedLeadIds] = useState([]);
  const [selectedChannelKind, setSelectedChannelKind] = useState(null);

  const toggleLead = useCallback((leadId, channelKind) => {
    setSelectedLeadIds((prev) => {
      if (prev.includes(leadId)) {
        const newIds = prev.filter(id => id !== leadId);
        if (newIds.length === 0) {
          setSelectedChannelKind(null);
        }
        return newIds;
      }
      if (prev.length === 0) {
        setSelectedChannelKind(channelKind);
      }
      return [...prev, leadId];
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedLeadIds([]);
    setSelectedChannelKind(null);
  }, []);

  const canSelectLead = useCallback((channelKind) => {
    if (selectedLeadIds.length === 0) {
      return true;
    }
    return selectedChannelKind === channelKind;
  }, [selectedLeadIds.length, selectedChannelKind]);

  return (
    <SelectedLeadsContext.Provider value={{
      selectedLeadIds,
      selectedChannelKind,
      toggleLead,
      clearSelection,
      canSelectLead,
    }}
    >
      {children}
    </SelectedLeadsContext.Provider>
  );
};
